import {
  adminCompany,
  adminCustomer,
  adminProduct,
  adminTags,
  adminCommunications,
  adminSecurity,
  adminStripe,
  adminBillingUpdateCard,
} from "./admin"
import {
  adminAccountsInternal,
  adminAccountsExternal,
  adminAccountsExternalTransaction,
  adminAccountsInternalTransaction,
} from "./adminAccounts"
import {
  adminReconciliation,
  adminReconciliationDetail,
} from "./adminBankReconciliation"
import { adminAccounts, adminMapping } from "./adminChartOfAccounts"
import {
  adminIntegrationsJournalEntries,
  adminIntegrationsJournalEntry,
  adminIntegrationsSettings,
} from "./adminIntegrations"
import {
  adminLocations,
  adminLocation,
  LocationTabs,
  LocationTab,
} from "./adminLocations"
import {
  adminManualJournalEntries,
  adminManualJournalEntry,
  adminNewManualJournalEntry,
  adminEditManualJournalEntry,
} from "./adminManualJournalEntries"
import {
  adminProfitAndLoss,
  adminBalanceSheet,
  adminPurchaseJournal,
  adminJournalEntries,
  adminPayouts,
  adminGeneralLedgerReport,
  adminReportBuilderReport,
} from "./adminReporting"
import { adminStaff, adminStaffs, StaffTabs, StaffTab } from "./adminStaff"
import {
  analyticsSummary,
  reportBuilder,
  reportBuilderReport,
} from "./analytics"
import { billPayments, billRefunds, bill, newBill } from "./bills"
import { cashManagement } from "./cashManagement"
import { credits, credit } from "./credits"
import {
  customer,
  jobs,
  customerContacts,
  customerStatementRuns,
  customerStatements,
  customerStatementsGenerate,
  customers,
  CustomerTab,
  CustomerTabs,
} from "./customers"
import { deliveriesCalendar, deliveriesList, delivery } from "./deliveries"
import { routine, routines } from "./dooey"
import { financeCharges, financeCharge } from "./financeCharges"
import { generalLedger } from "./generalLedger"
import {
  inventoryCount,
  inventoryCountsInProgress,
  inventoryCountsCompleted,
  inventoryCountsVoided,
} from "./inventoryCounts"
import { job } from "./jobs"
import { message, messages } from "./messages"
import { notifications } from "./notifications"
import { orders, order, orderStatusParam, buyersList } from "./orders"
import {
  orderShipments,
  orderShipment,
  orderShipmentStatusParam,
} from "./orderShipments"
import { pricingTier } from "./pricingTier"
import {
  customPrice,
  customPrices,
  newCustomPrice,
  product,
  products,
  promotion,
  promotions,
  newPromotion,
  priceChanges,
  promotionalPriceChanges,
  itemMaintenance,
  catalogProducts,
  spiffs,
  ProductTab,
  ProductTabs,
  giftCards,
  giftCard,
  GiftCardsBasePath,
  catalogSkus,
} from "./products"
import { sales, sale, saleStatusParam } from "./sales"
import { transfers, transfer, transferStatusParam } from "./transfers"
import { useDBStatus } from "./useDBStatus"
import { vendor, vendors } from "./vendors"

export const urls = {
  spiffs,
  cashManagement,
  credits,
  credit,
  customer,
  customers,
  jobs,
  customerContacts,
  customerStatementRuns,
  customerStatements,
  customerStatementsGenerate,
  job,
  message,
  messages,
  product,
  products,
  customPrice,
  customPrices,
  newCustomPrice,
  promotion,
  promotions,
  newPromotion,
  priceChanges,
  promotionalPriceChanges,
  itemMaintenance,
  catalogProducts,
  catalogSkus,
  vendor,
  vendors,
  inventoryCount,
  inventoryCountsInProgress,
  inventoryCountsCompleted,
  inventoryCountsVoided,
  sales,
  sale,
  saleStatusParam,
  transfers,
  transfer,
  transferStatusParam,
  orders,
  order,
  orderStatusParam,
  buyersList,
  orderShipments,
  orderShipment,
  orderShipmentStatusParam,
  billPayments,
  billRefunds,
  bill,
  newBill,
  financeCharges,
  financeCharge,
  useDBStatus,
  notifications,
  generalLedger,
  pricingTier,
  analyticsSummary,
  reportBuilder,
  reportBuilderReport,
  adminAccounts,
  adminMapping,
  adminLocations,
  adminLocation,
  adminIntegrationsSettings,
  adminIntegrationsJournalEntries,
  adminIntegrationsJournalEntry,
  adminStaff,
  adminStaffs,
  adminCompany,
  adminCustomer,
  adminProduct,
  adminTags,
  adminCommunications,
  adminSecurity,
  adminStripe,
  adminBillingUpdateCard,
  adminAccountsInternal,
  adminAccountsExternal,
  adminAccountsExternalTransaction,
  adminAccountsInternalTransaction,
  adminReconciliation,
  adminReconciliationDetail,
  adminProfitAndLoss,
  adminBalanceSheet,
  adminPurchaseJournal,
  adminJournalEntries,
  adminPayouts,
  adminGeneralLedgerReport,
  adminReportBuilderReport,
  adminManualJournalEntries,
  adminManualJournalEntry,
  adminNewManualJournalEntry,
  adminEditManualJournalEntry,
  giftCards,
  giftCard,
  GiftCardsBasePath,
  routine,
  routines,
  deliveriesCalendar,
  deliveriesList,
  delivery,
}

export { CustomerTabs, type CustomerTab }
export { ProductTabs, type ProductTab }
export { LocationTabs, type LocationTab }
export { StaffTabs, type StaffTab }
